import { PlayerSide } from '../types/game.types';
import type { TurnState } from '../types/game.types';
import type { Board } from '../entities/Board';

export class TurnSystem {
  private state: TurnState;

  constructor() {
    this.state = {
      currentSide: PlayerSide.KIWI,
      turnNumber: 1,
    };
  }

  get currentSide(): PlayerSide {
    return this.state.currentSide;
  }

  get turnNumber(): number {
    return this.state.turnNumber;
  }

  switchTurn(): void {
    this.state.currentSide =
      this.state.currentSide === PlayerSide.KIWI ? PlayerSide.COCONUT : PlayerSide.KIWI;
    this.state.turnNumber++;
  }

  checkWinCondition(board: Board): PlayerSide | null {
    const kiwis = board.getPiecesBySide(PlayerSide.KIWI);
    const coconuts = board.getPiecesBySide(PlayerSide.COCONUT);

    if (kiwis.length === 0) return PlayerSide.COCONUT;
    if (coconuts.length === 0) return PlayerSide.KIWI;
    return null;
  }

  reset(): void {
    this.state = {
      currentSide: PlayerSide.KIWI,
      turnNumber: 1,
    };
  }

  getState(): TurnState {
    return { ...this.state };
  }
}
